export enum FileContext {
	CHAT,
	TASKS,
	PROJECT,
	COMPANY_TEMPLATES,
}
